"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const icons_1 = require("../icons");
const theme_1 = require("../styles/theme");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const common_1 = require("../utils/common");
const styles = (theme) => (0, styles_1.createStyles)({
    root: {
        width: '100%',
        height: '100vh',
        background: theme_1.colors.snowWhite,
    },
    bottomLogo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px 0px 15.775px 0px',
        width: '100%',
        background: theme_1.colors.whiteSmoke,
        position: 'absolute',
        top: 0,
    },
    contentLeft: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        flex: 1,
        color: theme_1.colors.black0,
        marginRight: 40,
    },
    innerContentLeft: {
        position: 'absolute',
        top: '48%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 730,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            width: 346,
            top: '50%',
        }
    },
    contentRight: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: 1,
        color: theme_1.colors.black0,
        marginLeft: 40,
    },
    button: {
        backgroundColor: theme.palette.primary.main,
        textTransform: 'none',
        padding: '10.5px 25.5px 11.5px 16.5px',
        lineHeight: 'normal',
        borderRadius: 5,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        color: theme_1.colors.white,
        fontSize: 14,
        fontWeight: 500,
        height: 40,
        boxShadow: `0px 1px 4px 0px ${theme_1.colors.black15}`,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            width: '100%',
        }
    },
    primaryText: {
        fontSize: 26,
        fontWeight: 500,
        lineHeight: 'normal',
        color: theme_1.colors.black54,
        paddingTop: 24,
        paddingBottom: 8,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            fontSize: 22,
        }
    },
    secondaryText: {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 'normal',
        color: theme_1.colors.black54,
        textAlign: 'center',
        paddingBottom: 19,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            fontSize: 15,
        }
    },
    contactbtn: {
        padding: '7px 18.5px 8.625px 18.5px',
        background: theme_1.colors.white,
        boxShadow: `0px 1px 4px 0px ${theme_1.colors.black15}`,
        color: theme_1.colors.black54,
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 'normal',
        height: 40,
        borderRadius: 5,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            width: '100%',
        }
    },
    icon: {
        marginRight: 12,
        fontSize: 18,
    },
    contactIcon: {
        marginRight: 10,
        fontSize: 24,
    },
    buttonContainer: {
        display: 'flex',
        gap: 15,
        alignItems: 'center',
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            flexDirection: 'column',
            left: 23,
            right: 24,
            gap: 12,
            position: 'absolute',
            bottom: 28,
        }
    }
});
const ButtonContainer = ({ classesContainer, refreshPage }) => (react_1.default.createElement("div", { className: classesContainer.buttonContainer },
    react_1.default.createElement(core_1.Button, { className: classesContainer.button, onClick: refreshPage },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faArrowRotateLeft, className: classesContainer.icon })),
        "Refresh the Page"),
    react_1.default.createElement(core_1.Button, { className: classesContainer.contactbtn, href: "https://terragotech.com/support/submit-support-case/" },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCommentsQuestionCheck, className: classesContainer.contactIcon })),
        "Contact Support")));
const withMediaQuery = (WrappedComponent) => {
    return (props) => {
        const isMobileView = (0, core_1.useMediaQuery)(`(max-width: ${common_1.MOBILE_BREAKPOINT}px)`);
        return react_1.default.createElement(WrappedComponent, Object.assign({ isMobileView: isMobileView }, props));
    };
};
class ErrorBoundaryWeb extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
        this.refreshPage = () => {
            window.location.reload();
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    render() {
        const { classes, isMobileView } = this.props;
        const classesContainer = classes;
        if (this.state.hasError) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classesContainer.root },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: classesContainer.innerContentLeft },
                            react_1.default.createElement(icons_1.TGBroken, null),
                            react_1.default.createElement("div", { className: classesContainer.primaryText }, "Hmm...looks like something broke."),
                            react_1.default.createElement("div", { className: classesContainer.secondaryText }, "Something went wrong and we couldn't complete your request. Please refresh the page or return later. If this problem persists, contact our support team for further assistance."),
                            !isMobileView && react_1.default.createElement(ButtonContainer, { classesContainer: classesContainer, refreshPage: this.refreshPage }))),
                    isMobileView && react_1.default.createElement(ButtonContainer, { classesContainer: classesContainer, refreshPage: this.refreshPage })),
                react_1.default.createElement("div", { className: classesContainer.bottomLogo },
                    react_1.default.createElement(icons_1.TGLogoWeb, null))));
        }
        return this.props.children;
    }
}
exports.default = withMediaQuery((0, styles_1.withStyles)(styles)(ErrorBoundaryWeb));
//# sourceMappingURL=ErrorBoundaryWeb.js.map